import Vue from 'vue'
import Router from 'vue-router'
import Flight from '@/views/Flight/Flight'
import CodeAccept from '@/views/CodeAccept/CodeAccept'
import RedirectionLoader from '@/views/RedirectionLoader/RedirectionLoader'
import GeneralTermsAndConditions from '@/views/GeneralTermsAndConditions/GeneralTermsAndConditions'
import Info from '@/views/Info/Info'
import Privacy from '@/views/Privacy/Privacy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'Flight', component: Flight },
    { path: '/code_accept', name: 'CodeAccept', component: CodeAccept },
    { path: '/redirect', name: 'RedirectionLoader', component: RedirectionLoader },
    { path: '/general_terms_and_conditions', name: 'GeneralTermsAndConditions', component: GeneralTermsAndConditions },
    { path: '/about_us', name: 'AboutUs', component: Info },
    { path: '/privacy', name: 'Privacy', component: Privacy }
  ]
})
